"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoSelected = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const faTimesCircle_1 = require("@fortawesome/pro-solid-svg-icons/faTimesCircle");
const utils_1 = require("./utils");
const faSpinnerThird_1 = require("@fortawesome/pro-solid-svg-icons/faSpinnerThird");
const PhotoSelected = ({ photo, onRemovePhoto, isSendingAttachment }) => {
    const [photoUrl, setPhotoUrl] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        const setUrl = async () => {
            if (photo) {
                const url = await (0, utils_1.readURL)(photo);
                setPhotoUrl(url);
            }
        };
        if (!photo) {
            setPhotoUrl("");
            return;
        }
        setUrl();
    }, [photo]);
    if (!photo)
        return null;
    return ((0, jsx_runtime_1.jsx)(Wrapper, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("img", { src: photoUrl }, void 0), !isSendingAttachment && photoUrl && ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "circleSmall", icon: faTimesCircle_1.faTimesCircle, onClick: onRemovePhoto }, void 0)), isSendingAttachment && ((0, jsx_runtime_1.jsx)("div", { className: "spinner", children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: faSpinnerThird_1.faSpinnerThird }, void 0) }, void 0) }, void 0)), photo && !photoUrl && ((0, jsx_runtime_1.jsx)("div", { className: "spinner wide", children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: faSpinnerThird_1.faSpinnerThird }, void 0) }, void 0) }, void 0))] }, void 0) }, void 0));
};
exports.PhotoSelected = PhotoSelected;
const Wrapper = styled_components_1.default.div `
  padding: ${({ theme }) => `0 ${theme.spacings.xl} ${theme.spacings.xs}`};

  & > div {
    min-height: 5.5rem;
    position: relative;

    & > img {
      max-height: 5.5rem;
      margin-right: 0 !important;
      width: auto;
    }

    & > div:first-of-type:not(.spinner) {
      background-color: ${({ theme }) => theme.colors.whiteBase};
      cursor: pointer;
      font-size: 0.75rem;
      height: 0.75rem;
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(50%, -50%);
    }

    & > .spinner {
      height: 100%;
      top: 0;
      left: 0;
      position: absolute;
      width: 100%;

      & > div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        & > div {
          animation: rotate 1s infinite;
          color: ${({ theme }) => theme.colors.greenBase};
        }
      }
    }

    .wide {
      width: 5rem;
    }
  }

  @keyframes rotate {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
//# sourceMappingURL=PhotoSelected.js.map